import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { DispositivoFcmDTO, DispositivoFcmRemocaoDTO } from '../../models/dispositivo/dispositivo-fcm.model';

/**
 * Service REST para registro e desativacao de token FCM no backend.
 * POST /api/dispositivo - registrar token
 * DELETE /api/dispositivo - desativar token (com body)
 */
@Injectable({ providedIn: 'root' })
export class DispositivoFcmService {

  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  /** Registrar token FCM no backend (POST /api/dispositivo) */
  registrar(dto: DispositivoFcmDTO): Observable<void> {
    return this.http.post<void>(
      `${this.baseUrl}/dispositivo`,
      dto,
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
    );
  }

  /**
   * Desativar token FCM no backend (DELETE /api/dispositivo com body).
   * Usa HttpClient.request('DELETE') para enviar body no DELETE.
   */
  remover(dto: DispositivoFcmRemocaoDTO): Observable<void> {
    return this.http.request<void>('DELETE', `${this.baseUrl}/dispositivo`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: dto,
    });
  }
}
